/**
 * @file 写真・表紙を全画面で拡大して出す。
 *
 * @what: 画面いっぱいの暗幕に画像を1枚出す。暗幕のどこを押しても閉じ、下に「閉じる」を置く。
 *   描画先は body の直下 (createPortal) にする。
 * @why: 呼び出し元の位置に出すと、参考書ルートの表のように `contain: paint` を持つ入れ物の中では
 *   `position: fixed` が入れ物を基準にしてしまい、表の中だけで開く (代表の指摘、2026-09-08)。
 *   `contain: paint` は sticky なセルが横幅を押し広げる Chrome の挙動を封じるために必要なので、
 *   外せない。描画先を body へ移して、どの面から開いても画面全体に出るようにする。
 * @failure: 描画のみ。document が無い環境 (SSR) では呼ばれない。
 */

import { createPortal } from "react-dom";

export function PhotoOverlay({
  src,
  alt,
  label,
  referrerPolicy,
  onClose,
}: {
  src: string;
  alt: string;
  /** 読み上げに出す、この拡大表示の名前である。 */
  label: string;
  /** 外部の書影を出すときに no-referrer を渡す。 */
  referrerPolicy?: "no-referrer";
  onClose: () => void;
}) {
  return createPortal(
    <div className="study-log-photo-overlay" role="dialog" aria-label={label} onClick={onClose}>
      <img src={src} alt={alt} {...(referrerPolicy ? { referrerPolicy } : {})} />
      <button type="button" className="study-log-photo-close" onClick={onClose}>
        閉じる
      </button>
    </div>,
    document.body,
  );
}
